export default __webpack_public_path__ + "static/media/after_sound.9575ee5f.mp3";